// extracted by mini-css-extract-plugin
export default {"form":"FolderSelectionTemplate_form__drZ7h","button":"FolderSelectionTemplate_button__y07xL"};